import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { DriverinfosdriversComponent } from './driverinfosdrivers.component';
import { ShipInterface } from '../../../core/models';

@Component({
  selector: 'app-driverinfos',
  imports: [CommonModule, ReactiveFormsModule, DriverinfosdriversComponent],
  standalone: true,
  template: `
    <div [formGroup]="driverInfo" class="flex flex-col gap-y-4 py-5 w-full">
      <div
        class="flex flex-row flex-wrap items-center gap-x-3 gap-y-2 sm:justify-center w-full"
      >
        <h2
          class="text-base font-semibold leading-7 text-gray-900"
          [ngClass]="{
            'sm:pr-4': customDriverInput,
            'sm:pr-0': !customDriverInput,
          }"
        >
          Lenker Informationen
        </h2>
        <button
          (click)="addDriver()"
          *ngIf="customDriverInput"
          type="button"
          class="rounded-md disabled:opacity-25 bg-columbus-blue-600 px-3 py-2 sm:px-2.5 sm:py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-columbus-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
        >
          Hinzufügen
        </button>
      </div>

      <div
        class="flex flex-col gap-x-6 w-full"
        *ngIf="!customDriverInput; else customDrivers"
      >
        <div class="flex flex-col">
          <label for="driverInfo" class="mb-2 text-sm font-medium text-gray-700"
            >Url</label
          >
          <input
            id="url"
            type="Url"
            formControlName="url"
            class="text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Url eingeben..."
          />
        </div>
        <div class="flex flex-col sm:flex-row gap-y-3 sm:gap-y-0 pt-4">
          <!-- customer Input -->
          <div class="flex flex-col sm:pr-6 w-full sm:w-auto">
            <label
              for="customerNumber"
              class="mb-2 text-sm font-medium text-gray-700"
              >Kundennummer</label
            >
            <input
              id="customerNumber"
              type="number"
              formControlName="customerNumber"
              class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Kundennummer eingeben..."
            />
          </div>
          <!-- Other Input -->
          <div class="flex flex-col w-full sm:w-auto">
            <label
              for="orderNumber"
              class="mb-2 text-sm font-medium text-gray-700"
              >Auftragsnummer</label
            >
            <input
              id="orderNumber"
              type="number"
              formControlName="orderNumber"
              class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Auftragsnummer eingeben..."
            />
          </div>
        </div>
      </div>
      <ng-template #customDrivers>
        <div
          class="flex w-full mb-3"
          *ngFor="let driver of drivers.controls; let i = index"
        >
          <app-driverinfosdrivers
            class="pb-2"
            (delete)="onDelete($event, i)"
            [driver]="convertAbstractControl(driver)"
          />
        </div>
      </ng-template>
    </div>
  `,
  styles: ``,
})
export class DriverinfosComponent implements OnChanges {
  @Input({ required: true }) driverInfo!: FormGroup;
  @Input({ required: true }) company!: string | undefined;
  @Input({ required: true }) shipInfo!: ShipInterface;
  fb = inject(FormBuilder);
  customDriverInput = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['company']) {
      if (this.company === 'Dr. Richard') {
        // Patch specific driver info for Dr. Richard
        if (this.shipInfo.shipDrRichardNr) {
          this.driverInfo.patchValue({
            url: 'https://richard.at/kundenlogin/',
            customerNumber: this.shipInfo.shipDrRichardNr,
            drivers: [],
          });
        } else {
          this.driverInfo.patchValue({
            url: 'https://richard.at/kundenlogin/',
            drivers: [],
          });
        }
        this.customDriverInput = false;
      } else if (changes['company'] && !changes['company']['firstChange']) {
        // Patch specific driver info for Dr. Richard
        //this.driverInfo.reset();
        (this.driverInfo.get('drivers') as FormArray).clear();
        this.customDriverInput = true;
      } else {
        this.customDriverInput = true;
      }
    }
  }

  convertAbstractControl(aControl: AbstractControl) {
    return aControl as FormGroup;
  }

  addDriver() {
    if (this.drivers) {
      this.drivers.push(this.createDriver());
    }
  }

  createDriver() {
    return this.fb.group({
      driverName: [],
      driverTel: [],
    });
  }

  get drivers() {
    return this.driverInfo.get('drivers') as FormArray;
  }

  onDelete(value: boolean, index: number) {
    if (value) {
      this.drivers.removeAt(index);
    }
  }
}
